exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spacing{position:fixed;left:25px;top:25px}", ""]);

// exports
